// Need to use the React-specific entry point to import createApi
import { baseApi, baseApiForAuth } from "./baseApi";
import { getTokenForSetNewPassword } from "./localStorageService";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const userAuthApi = baseApiForAuth.injectEndpoints({
  // reducerPath: "userAuthApi",
  mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    // registerUser: builder.mutation({
    //   query: (data) => {
    //     return {
    //       url: "auth/signup",
    //       method: "POST",
    //       body: data,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    // }),
    // verifyRegisteredUser: builder.mutation({
    //   query: (data) => {
    //     return {
    //       url: "auth/verify-otp",
    //       method: "POST",
    //       body: data,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    // }),
    loginUser: builder.mutation({
      query: (user) => {
        return {
          url: "login",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    logoutUser: builder.mutation({
      query: (user) => {
        return {
          url: "logout",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    forgotPassword: builder.mutation({
      query: (user) => {
        return {
          url: "forgot-password",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    sendOtp: builder.mutation({
      query: (user) => {
        return {
          url: "/send-otp/mail",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    verifyEmailOtp: builder.mutation({
      query: (data) => {
        return {
          url: "verify-otp/forgot-password",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    setNewPassword: builder.mutation({
      query: (data) => {
        return {
          url: "set-password",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getTokenForSetNewPassword()}`,
          },
        };
      },
    }),
    // updateProfile: builder.mutation({
    //   query: (data) => {
    //     return {
    //       url: END_POINTS.AUTH.UPDATE,
    //       method: "PATCH",
    //       body: data,
    //       headers: {},
    //     };
    //   },
    // }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useRegisterUserMutation,
  useVerifyRegisteredUserMutation,
  useLoginUserMutation,
  useLogoutUserMutation,
  useForgotPasswordMutation,
  useSetNewPasswordMutation,
  useSendOtpMutation,
  useVerifyEmailOtpMutation,
} = userAuthApi;
